class PopupManager {
	constructor(triggerSelector) {
		this.triggerElements = document.querySelectorAll(triggerSelector);
		if (this.triggerElements.length > 0) {
			this.setupEvents();
		}
	}

	setupEvents() {
		this.triggerElements.forEach((item) => {
			item.addEventListener("click", this.showPopup.bind(this));
		});
	}

	showPopup(e) {
		const popup = this.createPopup();
		document.body.appendChild(popup);

		const overlay = this.createOverlay();
		document.body.appendChild(overlay);

		const style = this.createStyle();
		document.head.appendChild(style);

		// Initial content of the popup: asking for article link and campaign
		popup.innerHTML = `
        <span class="close-button" id="close-button">×</span>
        <div class="popup-content" id="popup-content" style="display: flex;flex-direction: column;align-items: center;max-width:770px">
            <h2 style="margin-bottom: 20px;font-size: 1.6em;color: var(--wp--preset--color--dark);width:80%">Select Article and Campaign</h2>
            <div class="question" style="margin-bottom: 5px;width: 100%;">
                <p style="margin: 0 0 8px;font-size: 21.14px;color: var(--wp--preset--color--dark);">Enter your article link:</p>
                <input type="text" id="article-link" placeholder="Enter article link" style="width: 100%;padding: 12px;font-size: 1em;border: 1px solid #ccc;border-radius: 8px;" />
            </div>
            <div class="question" style="margin-bottom: 25px;width: 100%;">
                <p style="margin: 0 0 8px;font-size: 21.14px;color: var(--wp--preset--color--dark);">Select Campaign:</p>
                <select id="campaign-select" >
                    <option value="engagement">Reader Engagement</option>
                    <option value="reader questions">Reader Questions</option>
                    <option value="donations">Donations</option>
                </select>
            </div>
            <button style="font-size: 1.1em;margin-top: 20px;display:flex;" id="submit-button">Submit</button>
        </div>
    `;

		const submitButton = document.getElementById("submit-button");
		const closeButton = document.getElementById("close-button");

		closeButton.addEventListener("click", this.closePopup.bind(this));

		const checkArticleLink = () => {
			const articleLinkInput = document.getElementById("article-link");
			if (articleLinkInput.value.trim() === "") {
				submitButton.disabled = true; // Disable if empty
				submitButton.style.backgroundColor = "#cccccc"; // Change to disabled color
			} else {
				submitButton.disabled = false; // Enable if filled
				submitButton.style.backgroundColor = "#007BFF"; // Change to active color
			}
		};

		const articleLinkInput = document.getElementById("article-link");
		articleLinkInput.addEventListener("input", checkArticleLink);
		checkArticleLink();

		submitButton.addEventListener("click", this.handleSubmit.bind(this));

		// Dynamically attach slider event listeners when popup is shown
		const contentDiv = document.getElementById("popup-content");

		contentDiv.addEventListener("input", (event) => {
			// Check if the input is a slider and its parent is a question container
			if (
				event.target &&
				event.target.type === "range" &&
				event.target.closest(".question-container")
			) {
				this.handleSliderChange(event.target);
			}
		});
	}

	

	handleSliderChange(slider) {

		// Range Mapper function
		const scale = (fromRange, toRange) => {
        const d = (toRange[1] - toRange[0]) / (fromRange[1] - fromRange[0]);
			return from =>  (from - fromRange[0]) * d + toRange[0];
		};

		// Pixel to rem conversion function
		const getRangeValue = (slider) => {
			const rem = slider.offsetWidth / parseFloat(getComputedStyle(document.documentElement).fontSize);
			return rem;
		}

		const sliderValue = slider.nextElementSibling; // The value display span should be the next sibling of the slider

		// Show the value when the slider is moved
		sliderValue.style.display = "block";

		// Update the value dynamically as the slider moves
		sliderValue.textContent = slider.value;

		// Get the slider width in rem
		const rengeValue = getRangeValue(slider);

		// Calculate the percentage of the slider's value within its range
		const percentage = ((slider.value - slider.min) / (slider.max - slider.min));
		
		// Map percentage range to a range in rem calculating thumb offset (1rem)
		const mapedPercentage = scale([0, 1], [1, rengeValue - 1])(percentage);
		
		// Position the value above the slider thumb, ensuring it stays with the thumb
		sliderValue.style.left = `calc(${mapedPercentage}rem)`;

		// Optional: Adjust the top position of the value if needed
		sliderValue.style.top = `-25px`; // Adjust the value display above the slider thumb (use negative values for above)
	}

	async handleSubmit() {
		const articleLink = document.getElementById("article-link").value;
		const selectedCampaign =
			document.getElementById("campaign-select").value;

		// Close the initial popup content and display survey widget
		const contentDiv = document.getElementById("popup-content");
		contentDiv.innerHTML = `
			<div class="loading-container" style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
				<img src="https://img.icons8.com/ios/50/hourglass-sand-top--v1.png" alt="hourglass-sand-top--v1" width="50" height="50" style="margin-bottom: 20px; animation: rotate 1.5s linear infinite;" />
				<div class="loading-text" style="font-size: 1.2em; color: var(--wp--preset--color--dark);text-align: center;">Hang on, the questions you could ask your audience with Qurio are loading</div>
			</div>
		`;

		// Fetch survey data from OpenAI (call OpenAI API)
		await this.fetchSurveyData(articleLink, selectedCampaign);
	}

	async fetchSurveyData(articleLink, selectedCampaign) {
		console.log("selected template type", selectedCampaign);
		console.log("selected article link", articleLink);
		try {
			// Call OpenAI's API to generate survey questions
			const surveyData = await this.generateQuestions({
				postID: articleLink,
				templateType: selectedCampaign, // Specify the template you want to use
			});
			console.log("Survey Data response from model:", surveyData);

			// Render survey widget with fetched data
			this.renderSurveyWidget(surveyData);
		} catch (error) {
			console.error("Error fetching survey data:", error);
			document.querySelector(".loading").innerHTML =
				"Failed to load survey questions. Please try again later.";
		}
	}

	async generateQuestions({
		postID,
		postTitle,
		postContent,
		templateType,
		language = "English",
		platform = "article_link",
	}) {
		if (!postID || !templateType) {
			throw new Error("postID and templateType are required");
		}
		const questionLength = 70;
		const prompts = {
			engagement:
				"You are an engagement editor for a digital news publication. Your task is to generate a callout with questions based on a news article provided below. " +
				"The callout should be related to the content of the article and aim to increase time spent on the page and visitor engagement.\n\n " +
				"The questions should be asking people about their opinions, asking them to share related experiences, their feelings and if they have any information that could share our future coverages." +
				"The callouts should consist of seven thoughtful and empathetic questions each no longer than " +
				questionLength +
				" characters.\n\n " +
				"Come up with two open-ended questions, three multiple choice questions and two slider questions.\n\n" +
				"Order the questions in such a way, so that it creates a narrative and make sense to the reader.\n\n",
			// Add other prompts here as needed...
		};

		const formatPrompt = (language, questionLength) =>
			`Reply in JSON format. Do not include \`\`\`json in your response. ` +
			`The response must be in ${language} language. ` +
			`Create a descriptive "Heading" for this callout. Heading should capture the purpose of the callout and questions you came up with. Heading should be maximum ${questionLength} characters long.` +
			`Include an array of "questions" where each question has a "title" maximum of ${questionLength} characters, "type", and "value" if needed, with "min" and "max" for sliders. ` +
			`Follow this Schema: {"Heading": String, "questions": [{"title": String, "type": "text" | "multiple choice" | "slider", "value": [], "min": 0, "max": 10}]}. ` +
			`The JSON should start with the [ symbol. Use "value" for multiple choice options.`;

		const effectivePrompt =
			platform === "article_link"
				? prompts[templateType] +
				  "\n Get the article title and content from the link: " +
				  postID +
				  "\n\n" +
				  formatPrompt(language, questionLength)
				: prompts[templateType] +
				  "\nArticle Title: " +
				  postTitle +
				  "\nArticle Content: " +
				  postContent?.replace(/<[^>]+>/g, "") +
				  "\n\n" +
				  formatPrompt(language, questionLength);

		const response = await fetch(
			"https://api.openai.com/v1/chat/completions",
			{
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: `Bearer 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`,
				},
				body: JSON.stringify({
					model: "gpt-4o",
					messages: [{ role: "user", content: effectivePrompt }],
				}),
			}
		);

		const result = await response.json();
		const finalOutput = result.choices[0].message.content;
		const parsed = JSON.parse(finalOutput);

		return this.formatQuestions(parsed);
	}

	formatQuestions(question) {
		const heading = question[0]?.Heading || "";
		const questionData = question[0]?.questions || [];

		const formattedQuestions = questionData.map((q, index) => ({
			title: q.title || "",
			id: q.title || "",
			description: q.description || "",
			type: q.type || "",
			required: true,
			order: index,
			value: Array.isArray(q.value)
				? q.value.map((v) => v.toString())
				: [],
			min: q.min ?? null,
			max: q.max ?? null,
		}));

		return {
			Heading: heading,
			questions: formattedQuestions,
		};
	}

	renderSurveyWidget(surveyData) {
		const contentDiv = document.getElementById("popup-content");
		contentDiv.innerHTML = ""; // Clear loading message
		// contentDiv.style.width = "80%";

		// Insert the HTML for the survey widget
		const widgetDiv = document.createElement("div");
		widgetDiv.style.width = "100%";
		widgetDiv.innerHTML = this.getSurveyHTML(surveyData);
		contentDiv.appendChild(widgetDiv);

		// Bind event listeners for navigation buttons
		document
			.getElementById("prev-btn")
			.addEventListener("click", () => this.changeQuestion(-1));
		document
			.getElementById("next-btn")
			.addEventListener("click", () => this.changeQuestion(1));

		// Update button visibility
		this.updateNavigationButtons(0, surveyData.questions.length); // Initially show the first question
	}

	getSurveyHTML(surveyData) {
		let surveyHTML = "";

		surveyData.questions.forEach((question, index) => {
			// Ensure only one question is visible at a time
			surveyHTML += `
            <div class="question-container" id="question-${index}" style="display: ${
				index === 0 ? "block" : "none"
			};">
                <div class="question">
                    <h3>${question.title}</h3>
                </div>
                ${this.getQuestionInput(question)}
            </div>
        `;
		});

		// Navigation with arrows
		surveyHTML += `
        <div class="navigation" style="display: flex;justify-content: space-between;">
            <button id="prev-btn" class="nav-button" style="display: none;">
                <span class="arrow">&#8592;</span> <!-- Left arrow -->
            </button>
            <button id="next-btn" class="nav-button">
                <span class="arrow">&#8594;</span> <!-- Right arrow -->
            </button>
        </div>
    `;

		// Add the Submit button at the end, initially hidden
		surveyHTML += `
			<button id="submit-buton" class="nav-button" style="display: none; margin: 20px auto; padding: 12px 40px; background-color: #8c3126; color: white; border: none; border-radius: 8px; cursor: pointer; font-size: 18px; display: flex;">
				Submit
			</button>
		`;

		return surveyHTML;
	}

	getQuestionInput(question) {
		let inputHTML = "";

		switch (question.type) {
			case "text":
				inputHTML = `
                <input  class="text-input" id="input-text" placeholder="Enter your answer">
            `;
				break;
			case "open-ended":
				inputHTML = `
                <input  class="text-input" id="input-text" placeholder="Enter your answer">
            `;
				break;
			case "multiple choice":
				inputHTML = question.value
					.map(
						(option) => `
                    <label class="option-container">
                        <input type="radio" name="${question.id}" value="${option}" class="radio-option">
                        <span class="option-label">${option}</span>
                    </label>
                `
					)
					.join("");
				break;
			case "slider":
				inputHTML = `
                <div class="slider-container">
                    <input type="range" class="slider" min="${
						question.min || 0
					}" max="${question.max || 10}" value="5" id="slider-input">
                    <span id="slider-value" class="slider-value" style="left: 50%">${5}</span> <!-- Current value above thumb -->
                </div>
                <div class="slider-labels">
                    <span>${question.min || 0}</span>
                    <span>${question.max || 10}</span>
                </div>
            `;
				break;
			default:
				break;
		}

		return inputHTML;
	}

	changeQuestion(direction) {
		const questions = document.querySelectorAll(".question-container");
		let currentQuestionIndex = Array.from(questions).findIndex(
			(q) => q.style.display === "block"
		);

		// Hide the current question
		questions[currentQuestionIndex].style.display = "none";

		// Update the index
		currentQuestionIndex += direction;

		// Ensure the index is within bounds
		if (currentQuestionIndex < 0) currentQuestionIndex = 0;
		if (currentQuestionIndex >= questions.length)
			currentQuestionIndex = questions.length - 1;

		// Show the next/previous question
		questions[currentQuestionIndex].style.display = "block";

		// Disable/enable the buttons based on current question
		this.updateNavigationButtons(currentQuestionIndex, questions.length);
	}
	showThankYou() {
		const contentDiv = document.getElementById("popup-content");
		contentDiv.innerHTML = `
			<div class="thank-you" style="text-align: center;margin-top: 30px;">
				<h2>Thank you!</h2>
				<p>Join our newsletter to follow us!</p>
				<button class="submit-bton" style="display: block;margin: 30px auto 0;padding: 12px 40px;background-color: #8c3126;color: white;border: none;border-radius: 8px;font-size: 18px;cursor: pointer;" onclick="window.location.href='https://www.getqurio.com'">
					Join Now
				</button>
				<div style="display: flex; justify-content: center; align-items: center; margin-top: 20px;">
					<p style="font-size: 1em; color: var(--wp--preset--color--dark); margin-right: 10px;">Powered by</p>
					<img src="https://app.getqurio.com/logo.png" alt="Qurio Logo" style="max-width: 100px;"/>
				</div>
			</div>
		`;
	}
	updateNavigationButtons(currentIndex, totalQuestions) {
		const prevButton = document.getElementById("prev-btn");
		const nextButton = document.getElementById("next-btn");
		const submitButton = document.getElementById("submit-buton");

		// Hide the previous button on the first question
		prevButton.style.display = currentIndex === 0 ? "none" : "inline-block";

		// Hide the next button on the last question and show submit button
		if (currentIndex === totalQuestions - 1) {
			nextButton.style.display = "none";
			submitButton.style.display = "flex";
			submitButton.addEventListener("click", this.showThankYou);
		} else {
			nextButton.style.display = "inline-block";
			submitButton.style.display = "none";
		}

		// If only next button, align it to the right
		if (
			nextButton.style.display === "inline-block" &&
			prevButton.style.display === "none"
		) {
			nextButton.style.marginLeft = "auto"; // Right-align next button
		} else {
			nextButton.style.marginLeft = "0"; // Reset if both buttons are visible
		}
	}

	createPopup() {
		const popup = document.createElement("div");
		popup.id = "custom-popup";
		popup.classList.add("popup");
		return popup;
	}

	createOverlay() {
		const overlay = document.createElement("div");
		overlay.classList.add("overlay");
		return overlay;
	}

	createStyle() {
		const style = document.createElement("style");
		style.innerHTML = `
            .overlay {
                position: fixed;
				top: 0;
				left: 0;
				width: 100vw; /* Ensure it spans the entire width of the viewport */
				height: 100vh; /* Ensure it spans the entire height of the viewport */
				background: rgba(0, 0, 0, 0.5);
				backdrop-filter: blur(5px); /* Optional: adds blur to background */
				z-index: 999;
				display: flex;
				justify-content: center;
				align-items: center;
            }
            .popup {
                display: block;
                position: fixed;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                background-color: white;
                padding: 40px;
                border-radius: 12px;
                box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.2);
                z-index: 1000;
            }
			#custom-popup {
				display: flex;
				flex-direction: column;
				align-items: center; /* Center horizontally */
				justify-content: center; /* Center vertically */
				width: 100%; /* Ensures it takes full width */
				max-width: 770px; /* Optional: Set max width */
				height: 500px;
				border-radius:30px;
				box-sizing: border-box;
			}
            .popup-content {
                display: flex;
                flex-direction: column;
                align-items: center;
				width:80%;
            }

            .popup h2 {
                margin-bottom: 20px;
                font-size: 1.6em;
                color: var(--wp--preset--color--dark);
            }
            .text-input {
                width: 100%;
                padding: 15px;
                border-radius: 18px;
                border: none;
                background-color: #8c3126;
                color: white;
                font-size: 18px;
                margin-bottom: 20px;
                box-sizing: border-box;
            }
            .text-input::placeholder {
                color: rgba(255, 255, 255, 0.7);

            }
			#text-input {
                width: 100%;
                padding: 15px;
                border-radius: 18px;
                border: none;
                background-color: #8c3126;
                color: white;
                font-size: 18px;
                margin-bottom: 20px;
                box-sizing: border-box;
            }
            #text-input::placeholder {
                color: rgba(255, 255, 255, 0.7);

            }
			@keyframes rotate {
				0% {
					transform: rotate(0deg);
				}
				100% {
					transform: rotate(360deg);
				}
			}
            .option-container {
                padding: 15px;
                background-color: #8c3126;
                color: white;
                margin-bottom: 10px;
                border-radius: 8px;
                display: flex;
                align-items: center;
            }
            .radio-option {
                margin-right: 10px;
            }
            .slider {
                width: 100%;
                height: 5px;
                background: #d3d3d3;
                border-radius: 5px;
                margin: 20px 0;
            }
            .slider::-webkit-slider-thumb {
                width: 20px;
                height: 20px;
                border-radius: 50%;
                background: #000;
            }
            .nav-button {
                padding: 12px 18px;
                background-color: #8c3126;
                color: white;
                border: none;
                border-radius: 8px;
                cursor: pointer;
            }
            .close-button {
                position: absolute;
                top: 10px;
                right: 20px;
                font-size: 30px;
                color: var(--wp--preset--color--dark);
                cursor: pointer;
				transition: all 200ms;
				font-size: 30px;
				font-weight: 700;
				text-decoration: none;
				color: var(--wp--preset--color--dark);
				background: transparent;
				border-radius: 0;
				padding: 0;
            }
			.text-input, .question select {
				width: 100%;
				padding: 12px;
				font-size: 1em;
				border: 1px solid #ccc;
				border-radius: 8px;
				width: 100%; /* Ensure it takes full width of the container */
				padding: 12px;
				font-size: 1em;
				border: 1px solid #ccc;
				border-radius: 8px;
				box-sizing: border-box; /* Ensure padding does not exceed width */
				appearance: none; /* Remove default dropdown appearance */
				-webkit-appearance: none; /* Remove default dropdown appearance on mobile Safari */
				-moz-appearance: none; /* Remove default dropdown appearance on Firefox */
				background-color: white; /* Ensures background is solid */
				background-image: url('data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 16 16%22%3E%3Cpath fill=%22none%22 d=%22M2 4l6 6 6-6%22/%3E%3C/svg%3E'); /* Custom arrow */
				background-position: right 10px center; /* Position arrow to the right */
				background-repeat: no-repeat; /* Prevent repeated background */
				background-size: 12px; /* Size of the arrow */
			}

			.slider-container {
				position: relative;
				width: 100%;
				height: 30px;
				margin-top: 15px;
			}

			/* Add min/max labels just below the slider */
			.slider-labels {
				width: 100%;
				display: flex;
				justify-content: space-between;
				top: 20px; /* Moves the labels just below the slider */
				font-size: 14px;
				color: var(--wp--preset--color--dark);
				gap:95%;
			}

			/* Set proper spacing between the slider and the labels */
			.slider-labels span {
				width: 50%;
				text-align:center;
				font-size: 14px;
				font-weight: bold;
				color: var(--wp--preset--color--dark);
			}

			/* Style for the range slider itself */
			.slider {
				width: 100%;
				height: 5px;
				background: #d3d3d3;
				border-radius: 5px;
				margin: 0;
				position: relative;
				z-index: 1;
			}

			/* Style for the thumb of the slider */
			.slider::-webkit-slider-thumb {
				width: 20px;
				height: 20px;
				border-radius: 50%;
				background: #007BFF;
				cursor: pointer;
				position: relative;
				z-index: 2;
			}

			/* Same style for Firefox and other browsers */
			.slider::-moz-range-thumb {
				width: 20px;
				height: 20px;
				border-radius: 50%;
				background: #007BFF;
				cursor: pointer;
				position: relative;
				z-index: 2;
			}

			/* Same style for IE */
			.slider::-ms-thumb {
				width: 20px;
				height: 20px;
				border-radius: 50%;
				background: #007BFF;
				cursor: pointer;
				position: relative;
				z-index: 2;
			}

			/* Current value displayed just above the thumb */
			.slider-value {
				position: absolute;
				top: -25px; /* Position above the slider */
				left: 0;
				transform: translateX(-50%);
				font-size: 14px;
				font-weight: bold;
				color: var(--wp--preset--color--dark);
				display: none; /* Initially hidden */
			}


			.question input:focus, .question select:focus {
				border-color: #007BFF;
			}
			@media (max-width: 768px) {
				.popup-content {
					width: 100%; /* Full width on smaller screens */
					padding: 0 10px; /* Optional: Add some padding on mobile if needed */
				}
				.campaign-select {
					width: 100%; /* Ensure it takes full width on smaller screens */
					font-size: 1.1em; /* Adjust font size for better readability */
				}
			}
        `;
		return style;
	}

	closePopup() {
		const popup = document.getElementById("custom-popup");
		const overlay = document.querySelector(".overlay");
		if (popup && overlay) {
			document.body.removeChild(popup);
			document.body.removeChild(overlay);
			document.head.removeChild(document.querySelector("style"));
		}
	}
}

export default PopupManager;
